import GenericModal from 'components/UI/V3/Modals/GenericModal';
import styles from './EditPriceModal.module.scss';
import { FunctionComponent, ReactNode, useEffect, useState } from 'react';
import Button from 'components/UI/V3/Button/Button';
import { PriceField } from 'components/UI/PriceField';

interface EditPriceModalProps {
    currentPrice: number;
    onSave: (newPrice: number) => void;
    onCancel: () => void;
    infoBanner?: ReactNode;
    isLoading?: boolean;
}

const EditPriceModal: FunctionComponent<EditPriceModalProps> = props => {
    const [price, setPrice] = useState<number | undefined>(props.currentPrice);
    const loading = props.isLoading || false;

    useEffect(() => {
        setPrice(props.currentPrice);
    }, [props.currentPrice]);

    const handleSave = () => {
        if (price === undefined) {
            return;
        }

        props.onSave(price);
    };

    return (
        <GenericModal
            footer={
                <div className={styles.footer}>
                    <Button
                        size="large"
                        className={styles.button}
                        label="Cancel"
                        onClick={props.onCancel}
                        variant="black"
                        disabled={loading}
                    />
                    <Button
                        size="large"
                        className={styles.button}
                        label="Save"
                        onClick={handleSave}
                        variant="green"
                        isLoading={loading}
                        disabled={loading || price === undefined}
                    />
                </div>
            }
            onClose={props.onCancel}
            className={styles.modal}
        >
            <div className={styles.content}>
                <span className={styles.title}>Edit price</span>
                <PriceField
                    id="membership-price"
                    className={styles.priceInput}
                    value={price}
                    min={0}
                    fixedDecimalScale
                    onChange={setPrice}
                    disabled={loading}
                />
                {props.infoBanner}
            </div>
        </GenericModal>
    );
};

export default EditPriceModal;
